/**
 * Estilos do react-select alinhados ao theme MUI (theme_v2), para dark/light.
 * @param {import('@mui/material/styles').Theme} theme
 * @param {{ menuZIndex?: number }} [options]
 */
export function getReactSelectStyles(theme, options = {}) {
  const { palette, zIndex } = theme;
  const menuZ = options.menuZIndex ?? zIndex.modal;

  return {
    control: (base, state) => ({
      ...base,
      cursor: 'default',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      fontSize: 14,
      minHeight: 38,
      minWidth: 0,
      width: '100%',
      backgroundColor: palette.background.paper,
      borderColor: state.isFocused ? palette.primary.main : palette.divider,
      boxShadow: state.isFocused ? `0 0 0 1px ${palette.primary.main}` : 'none',
    }),
    menu: (base) => ({
      ...base,
      marginTop: 4,
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      fontSize: 13,
      backgroundColor: palette.background.paper,
      zIndex: menuZ,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: menuZ,
    }),
    menuList: (base) => ({
      ...base,
      backgroundColor: palette.background.paper,
    }),
    option: (base, state) => ({
      ...base,
      cursor: 'default',
      backgroundColor: state.isSelected
        ? palette.primary.main
        : state.isFocused
          ? palette.action.hover
          : 'transparent',
      color: state.isSelected
        ? palette.primary.contrastText
        : palette.text.primary,
    }),
    singleValue: (base) => ({
      ...base,
      color: palette.text.primary,
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: palette.action.selected,
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: palette.text.primary,
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: palette.text.secondary,
    }),
    input: (base) => ({
      ...base,
      color: palette.text.primary,
    }),
    placeholder: (base) => ({
      ...base,
      color: palette.text.secondary,
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: palette.divider,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: palette.text.secondary,
    }),
    clearIndicator: (base) => ({
      ...base,
      color: palette.text.secondary,
    }),
    container: (base) => ({
      ...base,
      marginTop: 8,
      minWidth: 0,
      width: '100%',
    }),
  };
}
